import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { MarketingAnalyticsEvent, MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes';

export class MarketingAnalyticsUserActivityEventType extends MarketingAnalyticsEventType {
    canHandle(event: any): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_USER_ACTIVITY;
    }

    getBody(event: any): MarketingAnalyticsEvent {
        const baseEvent = this.baseEvent(event);
        baseEvent.object_identifier = event.objectIdentifier;
        return baseEvent;
    }
}
